module.exports = __webpack_public_path__ + "img/c4.98c4c106.png";